module.exports = __webpack_public_path__ + "static/media/lt.c2b153a4.svg";